import React from 'react';
import { Card } from '../components/ui/card';
import { Laptop, ShoppingCart, Coffee, Heart, Shirt, Briefcase, Factory, Film, Sparkles, Dumbbell, GraduationCap, Home, Car, DollarSign, Plane, Leaf, Trophy, Gamepad2, PawPrint, Recycle } from 'lucide-react';
import { mockData } from '../data/mockData';

const iconMap = {
  Laptop: Laptop,
  ShoppingCart: ShoppingCart,
  Coffee: Coffee,
  Heart: Heart,
  Shirt: Shirt,
  Briefcase: Briefcase,
  Factory: Factory,
  Film: Film,
  Sparkles: Sparkles,
  Dumbbell: Dumbbell,
  GraduationCap: GraduationCap,
  Home: Home,
  Car: Car,
  DollarSign: DollarSign,
  Plane: Plane,
  Leaf: Leaf,
  Trophy: Trophy,
  Gamepad2: Gamepad2,
  PawPrint: PawPrint,
  Recycle: Recycle
};

const IndustriesSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              Industries We Serve
            </h2>
            <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We provide trademark registration services for businesses across all industries and sectors in the United States. Our expertise spans diverse markets, from emerging startups to established enterprises.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {mockData.industries.map((industry, index) => {
              const IconComponent = iconMap[industry.icon];
              return (
                <Card
                  key={index}
                  className="p-6 text-center hover:shadow-xl transition-all duration-300 border-b-2 border-transparent hover:border-amber-500 group cursor-pointer"
                >
                  <div className="w-16 h-16 bg-blue-50 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-amber-500 transition-colors">
                    <IconComponent className="text-blue-900 group-hover:text-white transition-colors" size={32} />
                  </div>
                  <h3 className="text-base font-semibold text-blue-900 mb-2">
                    {industry.name}
                  </h3>
                  <p className="text-xs text-gray-500">
                    {industry.description}
                  </p>
                </Card>
              );
            })}
          </div>

          <div className="mt-12 bg-gradient-to-br from-blue-50 to-amber-50 rounded-2xl p-8 border border-blue-200">
            <div className="max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold text-blue-900 mb-4 text-center">
                Specialized Industry Expertise
              </h3>
              <div className="grid md:grid-cols-2 gap-6 text-gray-700">
                <div>
                  <h4 className="font-semibold text-blue-900 mb-2">Tech & Innovation</h4>
                  <p className="text-sm">We understand the unique challenges of protecting software names, app brands, and technology trademarks in rapidly evolving markets.</p>
                </div>
                <div>
                  <h4 className="font-semibold text-blue-900 mb-2">Consumer Goods</h4>
                  <p className="text-sm">Expertise in multi-class filings for products spanning multiple categories, from clothing to cosmetics to food products.</p>
                </div>
                <div>
                  <h4 className="font-semibold text-blue-900 mb-2">Service Industries</h4>
                  <p className="text-sm">Strategic trademark protection for service marks, including consulting, healthcare, and professional services.</p>
                </div>
                <div>
                  <h4 className="font-semibold text-blue-900 mb-2">Emerging Markets</h4>
                  <p className="text-sm">Forward-thinking strategies for new industries like cryptocurrency, NFTs, sustainable products, and green technology.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 text-center">
            <p className="text-lg text-gray-600 mb-2">
              <strong className="text-blue-900">Don't see your industry listed?</strong>
            </p>
            <p className="text-gray-700">
              We work with businesses from all sectors and industries. From startups to Fortune 500 companies, we protect brands across every market segment imaginable.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
